import axios from "axios";
import { getAuthorizationToken } from "../config/user";
const REACT_APP_API_URL = process.env.REACT_APP_API_URL;

function gethospitals(searchKey, page, limit) {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/hospital-name-list?searchKey=${searchKey}&page=${page}&limit=${limit}&status=ACTIVE`,
    headers: getAuthorizationToken(),
  });
}

function getHospitalSubscriptionList(searchKey, page, limit) {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/hospital-subscription-and-history?searchKey=${searchKey}&page=${page}&limit=${limit}`,
    headers: getAuthorizationToken(),
  });
}
function getSubscriptionList() {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/subscription-count`,
    headers: getAuthorizationToken(),
  });
}
function getHospitalUserList(searchKey, page = 1, limit = 10, pmjaystatus) {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/hospital-user-list?searchKey=${searchKey}&pmjaystatus=${pmjaystatus}&page=${page}&limit=${limit}`,
    headers: getAuthorizationToken(),
  });
}

function getHospitalCases(
  searchKey,
  page,
  limit,
  status = "",
  stageType,
  hsaStages,
  isTpa = 0,
) {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/hospital-all-cases?isTpa=${isTpa}&searchKey=${searchKey}&page=${page}&limit=${limit}&status=${status}&hsaStage=${stageType}&hsaStages=${encodeURIComponent(
      JSON.stringify(hsaStages),
    )}`,
    headers: getAuthorizationToken(),
  });
}
function getHospitalList(searchKey, page = 1, limit = 48) {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/hospital-subscription-and-history?searchKey=${searchKey}&page=${page}&limit=${limit}`,
    headers: getAuthorizationToken(),
  });
}

function addNewHospital(data) {
  return axios({
    method: "post",
    url: `${REACT_APP_API_URL}/add-new-hospital`,
    data: data,
    headers: getAuthorizationToken(),
  });
}
export const getInactiveHospitals = (searchKey, page, limit) => {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/inactive-hospitals?searchKey=${searchKey}&page=${page}&limit=${limit}`,
    headers: getAuthorizationToken(),
  });
};
function getHospitalPendingDocList(
  page,
  limit,
  hospitalIds,
  commandCenterStages,
) {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/hospital-pending-doc-list?page=${page}&limit=${limit}&commandCenterStages=${encodeURIComponent(
      JSON.stringify(commandCenterStages),
    )}&hospitalIds=${encodeURIComponent(JSON.stringify(hospitalIds))}`,
    headers: getAuthorizationToken(),
  });
}
function getSubStageNextAction() {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/sub-stage-next-action-pair`,
    headers: getAuthorizationToken(),
  });
}

export const addHospitalDetails = (values) => {
  return axios({
    method: "post",
    url: `${REACT_APP_API_URL}/add-new-hospital`,
    headers: getAuthorizationToken(),
    data: {
      name: values.name,
      country: values.country,
      state: values.state,
      city: values.city,
      pincode: values.pincode,
      businessDocumentType: values.businessDocumentType,
      businessDocumentUrl: values.businessDocumentUrl,
      businessDocumentNumber: values.businessDocumentNumber,
      logoUrl: values.logoUrl,
      tmsVersion: values.tmsVersion,
      pmjayUserId: "",
      locationDetails: values.locationDetails,
    },
  });
};
export const addHospitalUser = (values) => {
  return axios({
    method: "post",
    url: `${REACT_APP_API_URL}/add-hospital-user`,
    headers: getAuthorizationToken(),
    data: {
      name: values.name,
      roleName: "Hospital",
      phone: values.phone,
      email: values.email,
      hospitalId: values.hospitalId,
      password: values.password,
      tmsVersion: values.tmsVersion,
      fullName: values.fullName,
      position:
        values.position === "Other" ? values.otherPosition : values.position,
    },
    emailVerify: true,
    phoneVerify: true,
  });
};
export const mapSubscriptionToHospital = (values) => {
  return axios({
    method: "post",
    url: `${REACT_APP_API_URL}/superadmin-subscription-mapping`,
    headers: getAuthorizationToken(),
    data: {
      hospitalId: values.hospitalId,
      subscriptionId: values.subscriptionId,
      transactionId: values.transactionId,
      paymentType: values.paymentType,
      amount: values.amount,
      transactionDate: values.transactionDate,
      status: "paid",
    },
  });
};
export const mapSubscriptionPlan = (data) => {
  return axios({
    method: "post",
    url: `${REACT_APP_API_URL}/map-subscription-plan`,
    headers: getAuthorizationToken(),
    data: data,
  });
};

export const updatehospital = (hospitalId, data) => {
  return axios({
    method: "put",
    url: `${REACT_APP_API_URL}/update-hospital-details/${hospitalId}`,
    data: data,
    headers: getAuthorizationToken(),
  });
};

export const hospitalupdate = (hospitalId, data) => {
  return axios({
    method: "put",
    url: `${REACT_APP_API_URL}/update-hospital-details/${hospitalId}`,
    data: data,
    headers: getAuthorizationToken(),
  });
};
export const addUpdateTmsCredential = (data) => {
  return axios({
    method: "post",
    url: `${REACT_APP_API_URL}/add-update-tms-credential`,
    data: data,
    headers: getAuthorizationToken(),
  });
};
export const updateUserRpaDetails = (data) => {
  return axios({
    method: "patch",
    url: `${REACT_APP_API_URL}/update-user`,
    data: data,
    headers: getAuthorizationToken(),
  });
};

export const approveHospital = (hospitalId, status) => {
  return axios({
    method: "put",
    url: `${REACT_APP_API_URL}/hospital-status-update/${hospitalId}?status=${status}`,
    headers: getAuthorizationToken(),
  });
};
export const addDoctor = (values) => {
  const data = [{ ...values, specialityIds: [values.specialityIds] }];
  return axios({
    method: "post",
    url: `${REACT_APP_API_URL}/add-doctor`,
    data: data,
    headers: getAuthorizationToken(),
  });
};
function getUniqueSpecialityList(searchKey, page, limit) {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/unique-speciality-list?searchKey=${searchKey}&page=${page}&limit=${limit}`,
    headers: getAuthorizationToken(),
  });
}
function getAllDoctorsList(hospitalId = "", page = "", key = "") {
  let url = `${REACT_APP_API_URL}/doctors`;
  const params = [];
  if (hospitalId) params.push(`hospitalId=${hospitalId}`);
  if (page) params.push(`page=${page}`);
  if (key) params.push(`key=${key}`);
  if (params.length) url += "?" + params.join("&");

  return axios({
    method: "get",
    url,
    headers: getAuthorizationToken(),
  });
}

function getDoctorList(searchKey, page, limit, hospitalId = "") {
  let url = `${REACT_APP_API_URL}/doctors-list`;

  if (hospitalId) {
    url += `/${hospitalId}`;
  }

  url += `?specialityId=${searchKey}&page=${page}&limit=${limit}`;

  return axios({
    method: "get",
    url,
    headers: getAuthorizationToken(),
  });
}

function updateDoctorDetail(doctorId, doctorData) {
  return axios({
    method: "put",
    url: `${REACT_APP_API_URL}/update-doctor-detail?id=${doctorId}`,
    data: doctorData,
    headers: getAuthorizationToken(),
  });
}

function updateCareTeamDoctorDetail(payload) {
  const { doctorId, ...doctorData } = payload;

  return axios({
    method: "put",
    url: `${REACT_APP_API_URL}/update-doctor-detail?id=${doctorId}`,
    data: doctorData,
    headers: getAuthorizationToken(),
  });
}
function getHospitalStageCaseCount(hospitalId, isTpa = 0) {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/stage-case-count?hospitalId=${hospitalId}&isTpa=${isTpa}`,
    headers: getAuthorizationToken(),
  });
}
function getHospitalSpecialityMapping(hospitalId) {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/hospital-speciality-list?hospitalId=${
      hospitalId || null
    }`,
    headers: getAuthorizationToken(),
  });
}
function addHospitalSpecialityMapping(data) {
  return axios({
    method: "post",
    url: `${REACT_APP_API_URL}/add-hospital-speciality`,
    data: data,
    headers: getAuthorizationToken(),
  });
}
function deleteHospitalSpecialityMapping(id) {
  return axios({
    method: "delete",
    url: `${REACT_APP_API_URL}/delete-hospital-speciality?id=${id}`,

    headers: getAuthorizationToken(),
  });
}
function hospitalUserByRole(hospitalId, roleName) {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/hospital-user-by-role?hospitalId=${hospitalId}&roleName=${roleName}`,
    headers: getAuthorizationToken(),
  });
}
export const HospitalServices = {
  gethospitals,
  getHospitalCases,
  addNewHospital,
  mapSubscriptionPlan,
  getHospitalSubscriptionList,
  addDoctor,
  getUniqueSpecialityList,
  getDoctorList,
  getHospitalList,
  getHospitalUserList,
  updatehospital,
  hospitalupdate,
  updateUserRpaDetails,
  getHospitalStageCaseCount,
  updateDoctorDetail,
  updateCareTeamDoctorDetail,
  getAllDoctorsList,
  getHospitalSpecialityMapping,
  addHospitalSpecialityMapping,
  deleteHospitalSpecialityMapping,
  getHospitalPendingDocList,
  getSubStageNextAction,
  getSubscriptionList,
  hospitalUserByRole,
};
